import { t } from "i18next";
import { ComputeFieldComponent } from "../computeFields";
import { ArtworkInExhibition } from "../types";
import { SeparatedList } from "./shared/utils";
import { ComponentProps } from "react";

export const ExhibitionDescriptionCF: ComputeFieldComponent<
  Pick<
    ArtworkInExhibition,
    "exhibition" | "oeuvresDansExpositionsDescriptionNumeroCatalogue"
  >
> = ({ input, language, ...props }) => {
  return (
    <SeparatedList
      {...props}
      lineBreak={false}
      language={language}
      commaSeparated
      input={[
        <span
          dangerouslySetInnerHTML={{
            __html: input.exhibition.expositionsDescriptionResume,
          }}
        />,
        input.oeuvresDansExpositionsDescriptionNumeroCatalogue && (
          <>
            {t("computeField.numeroCatalogueAbbrege")}
            {input.oeuvresDansExpositionsDescriptionNumeroCatalogue}
          </>
        ),
      ]}
    />
  );
};

export const RelatedExhibitionsCF: ComputeFieldComponent<{
  relatedExhbitions?: ComponentProps<typeof ExhibitionDescriptionCF>["input"][];
}> = ({ input, lineBreak = true, ...props }) => {
  if (!input.relatedExhbitions || input.relatedExhbitions.length === 0) {
    return <></>;
  }

  return (
    <SeparatedList
      {...props}
      input={input.relatedExhbitions.map((item) => (
        <ExhibitionDescriptionCF
          input={item}
          lineBreak={lineBreak}
          {...props}
        />
      ))}
      lineBreak={lineBreak}
    />
  );
};
